import { render, staticRenderFns } from "./PodcastsCategory.vue?vue&type=template&id=e61c6c5c"
import script from "./PodcastsCategory.vue?vue&type=script&lang=ts"
export * from "./PodcastsCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports